import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './VisibilityTimer.scss';

const propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    start: PropTypes.number.isRequired,
    end: PropTypes.number,
    onEnd: PropTypes.func,
};

const defaultProps = {
    end: null,
    onEnd: null,
};

const VisibilityTimer = ({ activate, start, end, onEnd, children }) => {
    let activated = activate;
    let startTimeout;
    let endTimeout;

    const [visible, setVisible] = useState(false);

    const cleanup = () => {
        clearTimeout(startTimeout);
        if (end) {
            clearTimeout(endTimeout);
        }
    };

    useEffect(() => {
        if (activated) {
            startTimeout = setTimeout(() => {
                setVisible(true);
                if (!end && onEnd) {
                    onEnd();
                }
            }, start);

            if (end) {
                endTimeout = setTimeout(() => {
                    setVisible(false);
                    activated = false;
                    if (onEnd) {
                        onEnd();
                    }
                }, end);
            }
        } else {
            cleanup();
        }

        return () => {
            cleanup();
        };
    }, [activated]);

    const classes = classnames({
        VisibilityTimer: true,
        visible: visible, // eslint-disable-line
        hidden: !visible || !activated, // eslint-disable-line
    });

    return <div className={classes}>{children}</div>;
};

VisibilityTimer.propTypes = propTypes;
VisibilityTimer.defaultProps = defaultProps;

export default VisibilityTimer;
